module.exports = __webpack_public_path__ + "img/fish2.e7400184.png";